import { render, staticRenderFns } from "./CatalogTopMenu.vue?vue&type=template&id=e57e3a1c&"
import script from "./CatalogTopMenu.vue?vue&type=script&lang=js&"
export * from "./CatalogTopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports